<!-- Brand Logo -->
<a [routerLink]="['/']" class="brand-link">
  <img
    [src]="brand.markUrl"
    [alt]="brand.companyName"
    height="33"
    width="33"
    class="brand-image ml-3"
    style="opacity: 0.8; object-fit: contain" />

  <span class="brand-text font-weight-light">{{ brand.sidebarTitle }}</span>
</a>

<!-- Sidebar -->
<div class="sidebar">
  <!-- Sidebar user panel (optional) -->
  <!-- Sidebar user panel (optional) -->
  <div class="user-panel mt-3 pb-3 mb-3 d-flex">
    <div class="image">
      <img
        src="assets/img/default-profile.png"
        class="img-circle elevation-2"
        alt="User Image" />
    </div>
    <div class="info">
      <a class="d-block">{{
        loggedInUserName && loggedInUserName.length > 15
          ? (loggedInUserName | slice: 0 : 15) + '...'
          : loggedInUserName
      }}</a>
    </div>
  </div>

  <nav class="mt-2" class="overflow-hidden">
    <ul
      class="nav nav-pills nav-sidebar flex-column"
      data-widget="treeview"
      role="menu"
      data-accordion="false">
      <ng-container *ngFor="let item of menu">
        <!-- Check if the menu item has the required permissions -->
        <ng-container *ngIf="checkPermissions(item)">
          <app-menu-item [menuItem]="item"></app-menu-item>
        </ng-container>
      </ng-container>
    </ul>
  </nav>
</div>
